const DT = new Intl.DateTimeFormat("en-PH", { timeZone: "Asia/Manila", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: true });
const D = new Intl.DateTimeFormat("en-PH", { timeZone: "Asia/Manila", month: "short", day: "2-digit", year: "numeric" });

export const fmtDT = (iso) => (iso ? DT.format(new Date(iso)) : "—");
export const fmtDate = (iso) => (iso ? D.format(new Date(String(iso).length === 10 ? iso + "T00:00:00+08:00" : iso)) : "—");
export const peso = (n) => new Intl.NumberFormat("en-PH", { style: "currency", currency: "PHP" }).format(n || 0);
export const todayStr = () => new Date().toLocaleDateString("en-CA", { timeZone: "Asia/Manila" });

export const addDays = (dateStr, n) => {
  const d = new Date(dateStr + "T00:00:00+08:00");
  d.setDate(d.getDate() + n);
  return d.toLocaleDateString("en-CA", { timeZone: "Asia/Manila" });
};

export const hhmm = (t) => {
  if (!t) return "";
  const [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  const hh = h % 12 === 0 ? 12 : h % 12;
  return `${hh}:${String(m).padStart(2, "0")} ${ap}`;
};
